import { render, staticRenderFns } from "./UserActivateDialog.vue?vue&type=template&id=05f413f3&"
import script from "./UserActivateDialog.vue?vue&type=script&lang=js&"
export * from "./UserActivateDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "UserActivateDialog.vue"
export default component.exports